import { ChallengerEventData } from "./structs";

// ChallengerEvents - This class hosts the details about the in-browser events that occur while a ChallengerCore is running
export class ChallengerEvents {
    private eventData: ChallengerEventData;

    constructor() {
        this.eventData = new ChallengerEventData();
        this.addEvent(window, "click", this.onClick.bind(this));
        this.addEvent(window, "mousemove", this.onMouseMove.bind(this));
        this.addEvent(window, "keyup", this.onKeyUp.bind(this));
        this.addEvent(window, "touchstart", this.onTouchStart.bind(this));
    }

    //getBio - returns the eventData variable
    getBio(): ChallengerEventData {
        return this.eventData;
    }

    //addEvent - offers a variety of methods for attaching an event to a provided object
    private addEvent(e: EventTarget, t: string, n: () => void): void {
        e.addEventListener(t, n, false);
    }

    //updateTimeToNow - resets the "start_time" for the current eventData 
    updateTimeToNow(): void { this.eventData.start_time = Date.now(); }

    //onClick - called on mouse click events
    onClick(): void { this.eventData.mc += 1; }
    //onMouseMove - called on mouse move events 
    onMouseMove(): void {
        this.eventData.mm += 1;
        this.eventData.start_time = Date.now();
    }
    //onKeyUp - called on key up events (counts as a "keypress")
    onKeyUp(): void { this.eventData.kp += 1; }
    //onTouchStart - called on the start of a touchscreen action
    onTouchStart(): void { this.eventData.ts += 1; }
}
